import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Picture } from '@comparethemarketau/manor-picture';

import { SummaryTitle } from './common/summary_title';
import { SummarySubTitle } from './common/summary_sub_title';
import { ReviewAndEditYourDetails } from './common/review_and_edit_your_details';

import { getAssetFilePath } from './common/get_asset_file_path';
import { ContainerWrapper } from '../container_wrapper';
import { withAvailableQuotes } from '../products/common/with_available_quotes';
import { AlexanderNoResults } from '../empty_state/common/alexander_no_results';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        minHeight: '12rem'
    },
    leftContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around'
    },
    title: {
        fontWeight: theme.fontWeight.bold,
        fontSize: theme.fontSize.lg,
        color: theme.colors.grey900
    },
    subTitle: {
        fontSize: theme.fontSize.base
    },
    logo: {
        width: '10.2rem',
        height: '11.6rem'
    }
}));

const _PolicySummaryXs = ({ padding, availableQuotesSize }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    // Note: for the Picture Component the alt text has been set to empty because this is a Decorative Image - supplying
    // alt text here is only a distraction for visually impaired users - ensure that relevant alt text is included for
    // any informative, descriptive, or functional images / icons
    return (
        <ContainerWrapper padding={padding} className={classNames('test-policySummary-xs')}>
            <div className={classes.container}>
                <div className={classes.leftContainer}>
                    <div>
                        <SummaryTitle className={classes.title} />
                        <SummarySubTitle className={classes.subTitle} />
                    </div>
                    <ReviewAndEditYourDetails />
                </div>
                {
                    availableQuotesSize > 0
                        ? <Picture className={classes.logo} alt={''} src={getAssetFilePath('/assets/brand/ctm/images/alexander_half_excited_with_bg.png')} />
                        : <AlexanderNoResults className={classes.logo} />
                }
            </div>
        </ContainerWrapper>
    );
};

_PolicySummaryXs.propTypes = {
    padding: PropTypes.array,
    availableQuotesSize: PropTypes.number
};

const PolicySummaryXs = withAvailableQuotes(_PolicySummaryXs);

export { PolicySummaryXs };
